import { render, staticRenderFns } from "./ShopCourseLearn.vue?vue&type=template&id=12a1808c&scoped=true&"
import script from "./ShopCourseLearn.vue?vue&type=script&lang=js&"
export * from "./ShopCourseLearn.vue?vue&type=script&lang=js&"
import style0 from "./ShopCourseLearn.vue?vue&type=style&index=0&id=12a1808c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a1808c",
  null
  
)

export default component.exports